import { useState } from 'react';

const useResetState = initial => {
  const [value, setValue] = useState(initial);

  return [value, setValue, () => setValue(initial)];
};

export default useResetState;
